import AnimatedReactionPicker from './AnimatedReactionPicker';

export default AnimatedReactionPicker;
